import { query } from 'src/utils/request';

// 获取下拉框枚举值
export const getAuditList = (data) => {
  return query('/zlb/budget/api/asset/apply-form/audit-list', { 
    method: 'POST',
    data
  });
};
